// Typed shim for RevoGrid's `Template` cell renderer, which the wrapper exports at runtime but
// omits from its .d.ts.

import * as ReactDataGrid from '@revolist/react-datagrid';
import type { ComponentType } from 'react';
import type { CellTemplate } from '@revolist/revogrid';

type TemplateFn = (
  component: ComponentType<Record<string, unknown>>,
  customProps?: Record<string, unknown>
) => CellTemplate;

export const Template = (ReactDataGrid as unknown as { Template: TemplateFn })
  .Template;
